import { render, staticRenderFns } from "./Interacion.vue?vue&type=template&id=1e361450&scoped=true&"
import script from "./Interacion.vue?vue&type=script&lang=js&"
export * from "./Interacion.vue?vue&type=script&lang=js&"
import style0 from "./Interacion.vue?vue&type=style&index=0&id=1e361450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e361450",
  null
  
)

export default component.exports